import React from 'react'
import { observer } from 'mobx-react-lite'
import { useScheduleDateFiledContext } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/context/sendLaterContext'
import { DateContent } from './DateContent/DateContent'
import { DatetimeContent } from './DatetimeContent/DatetimeContent'

export const DateFiledSettings = observer(({ dropdownId }: { dropdownId: string }) => {
  const { dateFiledType } = useScheduleDateFiledContext()

  return (
    <>
      {dateFiledType === 'date' && <DateContent dropdownId={dropdownId} />}
      {dateFiledType === 'datetime' && <DatetimeContent dropdownId={dropdownId} />}
    </>
  )
})
